import {accountList,enablement,recharge,closeAccount,batchCloseAccount,checkRecharge,excelRecharge} from 'api/account';
import Cookies from 'js-cookie';

const account = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        //test
        accountList({commit},params) {
            return new Promise((resolve, reject) => {
                var accountBegin = params.accountBegin;
                var accountEnd = params.accountEnd;
                var imsiBegin = params.imsiBegin;
                var imsiEnd = params.imsiEnd;
                var productId = params.productId;
                var accoutStatus = params.accoutStatus;
                var agent = params.agent;
                var merchant = params.merchant;
                var psize = params.psize;
                var currentPage = params.currentPage;
                accountList(accountBegin,accountEnd,imsiBegin,imsiEnd,productId,accoutStatus,agent,merchant,psize,currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        enablement({commit},params) {
            return new Promise((resolve, reject) => {
                enablement(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        recharge({commit},params) {
            return new Promise((resolve, reject) => {
                recharge(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        closeAccount({commit},params) {
            return new Promise((resolve, reject) => {
                closeAccount(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        batchCloseAccount({commit},params) {
            return new Promise((resolve, reject) => {
                batchCloseAccount(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        checkRecharge({commit},params) {
            return new Promise((resolve, reject) => {
                checkRecharge(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        excelRecharge({commit},params) {
            return new Promise((resolve, reject) => {
                excelRecharge(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
    }
};

export default account;



// WEBPACK FOOTER //
// ./src/store/modules/account.js